export enum ProductTypeEnum {
    quantityProduct = 'QUANTITY_PRODUCT',
    priceProduct = 'PRICE_PRODUCT',
    discountedProduct = 'DISCOUNTED_PRODUCT',
    regularProduct = 'REGULAR_PRODUCT'
}